import { GroupApiModel } from '@api/api-models/site-settings';

export class ProgramUserListApiModel {
  public ProgramRoleId: string;
  public UserId: string;
  public FirstName: string;
  public LastName: string;
  public ShiftName: string;
  public LocationName: string;
  public PhaseName: string;
  public IsRemovable: boolean;
  public AvatarSrc: string;
  public AlertsCount: number;
  public Started: Date;
  public FullName: string;
  public Name: string;
  public Groups: GroupApiModel[];
  public IsSelected: boolean;
  public HasEndOfProgramActive: boolean;

  public deserialize(data: Object): ProgramUserListApiModel {
    Object.assign(this, data);

    this.FullName = `${this.LastName}, ${this.FirstName}`;
    this.Name = `${this.FirstName} ${this.LastName}`;

    return this;
  }
}
